module.exports = __webpack_public_path__ + "img/icon-note.18468f43.svg";